import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { Icon } from '@/components/custom-icon'

interface KolIntroTagsProps {
  customTags: string
}

export const KolIntroTags: FunctionComponent<KolIntroTagsProps> = ({
  customTags,
}) => {
  return (
    <TagsWrapper>
      <Icon type='elIconPriceTags' />
      {customTags.split('|').map((customTag, index) => (
        <Tag key={index}>{customTag}</Tag>
      ))}
    </TagsWrapper>
  )
}

const TagsWrapper = styled.div`
  margin: 15px 0 0 0;
  font-size: 16px;
  cursor: default;

  > .anticon {
    margin: 0 7px 0 0;
  }
`

const Tag = styled.span`
  margin: 0 5px 5px;
  line-height: 1.6;
  border-bottom: 3px solid #fddcda;
`
